var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDataReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 56,
    viewBox: "0 0 59 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0625 50.75H58.0625V39.25H0.0625V50.75ZM5.8625 42.125H11.6625V47.875H5.8625V42.125ZM0.0625 4.75V16.25H58.0625V4.75H0.0625ZM11.6625 13.375H5.8625V7.625H11.6625V13.375ZM0.0625 33.5H58.0625V22H0.0625V33.5ZM5.8625 24.875H11.6625V30.625H5.8625V24.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataReceived);
export default __webpack_public_path__ + "static/media/icon_data_received.5c1b23ed1fb3eaef111b57531b61b76c.svg";
export { ForwardRef as ReactComponent };